import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import priorityImg from '../../assets/about/priority.png';
import './Priority.scss';

const Priority = () => {
    return (
        <section className='priority-section emergency-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-img">
                            <img src={priorityImg} alt="Emergency" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-text">
                            <SectionTitle 
                                subTitle="OUR PRIORITY" 
                                title="Our clients are our priority"
                                description="At Dr. Mishqah Dollie’s practice, your comfort, confidence, and oral health are our top priorities. We are dedicated to delivering gentle, high-quality dental care in a welcoming environment—tailored to each patient’s needs. From young children to adults, every smile is treated with the compassion and professionalism it deserves."
                            />

                            <div className="theme-btn">
                                <a href="https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/" target="_blank" rel="noopener noreferrer">Book an appointment</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Priority;